import feathers from "../feathers";

export const setToken = token => {
  window.localStorage.setItem("mapplug-token", token);
};

export const getToken = () => {
  return window.localStorage.getItem("mapplug-token");
};

export const become = session => {
  setToken(session.token);
  window.location.href = "/";
};

// Delete the token and then force a
// full page reload to clear out any stored state (context)
// TODO: this should hit some backend enpoint to destroy these
// sessions
export const logOut = async () => {
  await feathers.logout();
  window.location.href = "/login";
};

export default {
  setToken,
  getToken,
  become,
  logOut
};



// WEBPACK FOOTER //
// ./src/lib/auth.js